import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { updateProjectStatus } from '@/features/projects/project-details/api/update-project-status';
import { useToast } from '@/shared/hooks/use-toast';

export const useUpdateProjectStatus = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });

  return useMutation({
    mutationFn: updateProjectStatus,
    onSuccess: () => {
      queryClient.invalidateQueries();
      toast({ title: t('project_status_saved') });
    },
    onError: () => {
      toast({
        title: t('project_status_error'),
        variant: 'destructive',
      });
    },
  });
};
